<template>
  <v-container id="descuentos" tag="section">
    <base-v-component heading="Descuentos del Negocio " />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn color="success" dark class="mb-2" @click.stop="goAdd()">{{
          formTitle
        }}</v-btn>
        <v-spacer />
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="descuentos"
        :loading="loading"
        disable-pagination
      >
        <template v-slot:item.acciones="{ item }">
          <v-card-actions class="pa-0 ma-0">
            <v-spacer></v-spacer>
            <v-tooltip top v-if="item.activo">
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="cambiarActivo(item)"
                  :loading="loadingActivo"
                  class="px-2 ml-1"
                  color="green"
                  min-width="0"
                  v-on="on"
                  small
                >
                  <v-icon small>mdi-check</v-icon>
                </v-btn>
              </template>
              <span>Desactivar</span>
            </v-tooltip>
            <v-tooltip top v-else>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="cambiarActivo(item)"
                  v-on="on"
                  class="px-2 ml-1"
                  :loading="loadingActivo"
                  color="red"
                  min-width="0"
                  small
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Activar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="goEdit(item)"
                  class="px-2 ml-1"
                  color="success"
                  min-width="0"
                  v-on="on"
                  small
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-btn
              class="px-2 ml-1"
              color="red"
              min-width="0"
              small
              @click="deleteItem(item)"
            >
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { mostrarIdioma } from "@/utils/utils.js";
export default {
  data() {
    return {
      loadingActivo: false,
      loading: false,
      headers: [
        {
          sortable: false,
          text: "Nombre",
          value: "nombre",
        },
        {
          sortable: false,
          text: "Descripción",
          value: "descripcion",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      negocio: "app/negocioGestObj",
    }),
    ...mapState({
      descuentos: (state) => state.descuentos.descuentosArray,
      idiomas: "idiomas",
      langDefecto: "langDefecto",
    }),
    langSeleccionado: {
      get() {
        return this.$store.state.langSeleccionado;
      },
      set(v) {
        this.$store.commit("setLangSeleccionado", v);
      },
    },
    subtitulo() {
      return "Listado de descuentos de " + this.negocio.nombre;
    },
    formTitle() {
      return "Nuevo Descuento";
    },
  },
  methods: {
    cambiarActivo(item) {
      var _vm = this;
      _vm.loadingActivo = true;
      this.$store
        .dispatch("descuentos/changeActivo", {
          id: item.id,
          activo: !(item.activo ? item.activo : false),
        })
        .then((res) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Descuento grabado con éxito",
          });
          return _vm.reload();
          _vm.dialog = false;
        })
        .catch((error) => {
          console.log(error);
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar el descuento",
          });
        })
        .finally(() => {
          _vm.loadingActivo = false;
        });
    },
    getDescuentos() {
      this.loading = true;
      let _vm = this;
      return this.$store.dispatch("descuentos/getDescuentos").finally(() => {
        _vm.loading = false;
      });
    },
    deleteItem(item) {
      let r = confirm("¿Quieres eliminar el descuento? (no se puede deshacer)");
      if (r) {
        this.loading = true;
        let _vm = this;
        this.$store
          .dispatch("descuentos/deleteDescuento", item)
          .then((res) => {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Descuento eliminado",
            });
            _vm.getDescuentos();
          })
          .catch((error) => {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al eliminar",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    reload() {
      this.getDescuentos();
    },
    goAdd() {
      let str = "/admin/gest/" + this.negocio.id + "/descuentos/add";
      this.$router.push(str);
    },
    goEdit(item) {
      let str =
        "/admin/gest/" + this.negocio.id + "/descuentos/edit/" + item.id;
      this.$router.push(str);
    },
  },
  mounted() {
    this.reload();
  },
};
</script>

<style>
</style>